import React, { useMemo, useRef } from 'react';
import { pluralizeWord } from '@npm-registry/helpers/pluralize';
import { Icon, Typography } from '@npm-registry/eapteka-ui';
import { useSelector } from 'react-redux';
import {
  selectLoading,
  selectSummary,
  selectTotalPrice
} from '../../../store/summary';
import { text } from '../../../text';
import { Submit } from './Submit';
import { Row } from './Row';
import { Informer } from './Informer';
import { Skeleton } from './Skeleton';
import styles from './Summary.scss';

export const Summary = () => {
  const submitContainer = useRef(null);
  const loading = useSelector(selectLoading);
  const totalPrice = useSelector(selectTotalPrice);
  const summary = useSelector(selectSummary);

  const {
    bonusProgramEarn,
    notification,
    discount,
    // deliveryPrice,
    // sberprime,
    productSummary,
    quantity,
    weight
  } = summary || {};

  const countLabel: string = useMemo(
    () =>
      quantity
        ? pluralizeWord(quantity, [
            text['oneItem'],
            text['fewItems'],
            text['manyItems']
          ])
        : '',
    [quantity]
  );

  return (
    <div className={styles.root}>
      <div className={styles.divider}></div>
      <div
        className={styles.submitContainer}
        ref={submitContainer}
      >
        <div className={styles.submitWrapper}>
          {notification && (
            <Informer>
              {
                <span
                  dangerouslySetInnerHTML={{
                    __html: notification
                  }}
                />
              }
            </Informer>
          )}

          <Submit
            price={totalPrice.valueFormatted}
            disabled={
              loading !== 'succeeded' ||
              totalPrice.value === 0
            }
          />
        </div>
      </div>

      {(loading === 'idle' || loading === 'pending') && (
        <Skeleton />
      )}

      {summary && loading !== 'pending' && (
        <div className={styles.wrapper}>
          <Row
            label={
              <Typography variant="p2">
                {quantity} {countLabel},{' '}
                {weight.valueFormatted}
              </Typography>
            }
            value={
              <Typography variant="p2">
                {productSummary.valueFormatted}
              </Typography>
            }
          />
          {discount.value > 0 && (
            <Row
              label={
                <Typography variant="p2">
                  {text['sale']}
                </Typography>
              }
              value={
                <Typography variant="p2">
                  -{discount.valueFormatted}
                </Typography>
              }
            />
          )}

          <Row
            isTotal
            label={
              <Typography
                className={styles.total}
                weight="strong"
              >
                {text['total']}
              </Typography>
            }
            value={
              <Typography
                className={styles.total}
                weight="strong"
              >
                {totalPrice.valueFormatted}
              </Typography>
            }
          />

          {bonusProgramEarn > 0 && (
            <Row
              label={
                <Typography variant="p2">
                  {text['addedBonuses']}
                </Typography>
              }
              value={
                <Typography
                  variant="p2"
                  className={styles.sale}
                >
                  <span>+{bonusProgramEarn}</span>
                  <Icon
                    name="eaptekaIcon"
                    gradientName="callicarpa"
                    className={styles.icon}
                  />
                </Typography>
              }
            />
          )}
        </div>
      )}
    </div>
  );
};
